import React from 'react'
import ProfileComponet from '../../components/ProfileComponet/Profile'

const Profile = () => {
  return (
    <div>
        <ProfileComponet/>
    </div>
  )
}

export default Profile